import type { LucideIcon } from "lucide-react";
import {
  BadgeCheck,
  BarChart3,
  Building2,
  Cookie,
  FormInput,
  Globe,
  Handshake,
  ScrollText,
} from "lucide-react";

export const LANDING_CHECK_ICONS: Record<string, LucideIcon> = {
  INN_FOUND: Building2,
  COMPANY_NAME_RESOLVED: BadgeCheck,
  PRIVACY_POLICY_FOUND: ScrollText,
  IS_DOMAIN_RUSSIAN: Globe,
  COOKIES_FOUND: Cookie,
  COOKIES_AGREEMENT_FOUND: Handshake,
  PRIVATE_DATA_FORMS_FOUND: FormInput,
  GOOGLE_ANALYTICS_REQUESTS_FOUND: BarChart3,
};
